module.exports = __webpack_public_path__ + "img/4_143.8b096783.png";